export default "/images/90b0ff555811d0d8c78afb7e14ce1eb1.avif";